import React from 'react'
import { useNetworkingBrief } from '../NetworkingBriefProvider'
import { EditorHeading } from '../../ResumeBuilder/Editor/common'
import { EditorItemTextField, EditorItemProvider } from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const ProfessionalIdentityEditor = () => {
  const { networkingBriefDocument: { professionalIdentity } = {} } =
    useNetworkingBrief()
  const { t } = useTranslation('ProfessionalIdentityEditor')

  return (
    <EditorItemProvider
      sectionName="professionalIdentity"
      item={professionalIdentity}
    >
      <div>
        <EditorHeading>{t('professional_identity')}</EditorHeading>
        <p> {t('personal_brand_statement_desc')}</p>
        <span className="font-bold">{t('example_label')}</span>
        <p>&quot;{t('example_text_1')}&quot;</p>
        <span className="font-bold">{t('example_label')}</span>
        <p>&quot;{t('example_text_2')}&quot;</p>
        <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
          <EditorItemTextField
            containerClassName="md:col-span-2"
            fieldName="personalBrandStatement"
            label={t('personal_brand_statement_label')}
            areaClassName="h-[150px]"
          />
        </div>
      </div>
    </EditorItemProvider>
  )
}
export default ProfessionalIdentityEditor
